<h2 class="ms-2">Ajouter un fichier</h2>
<div class="wrapper">
  <form>
    <div class="form-group mt-3" style="width: 445px">
      <label for="type">Type :</label>
      <select [(ngModel)]="file.type" class="form-control" name="type" id="type">
        <option value="certificate">Certificat</option>
        <option value="job">Job Talend</option>
      </select>
    </div>
    <div *ngIf="file.type ==='job'" class="form-group mt-3" style="width: 445px">
      <label for="product">Produit :</label>
      <select [(ngModel)]="file.product" class="form-control" name="product" id="product">
        <option *ngFor="let prod of productsArray" [value]="prod.produit_id">
          {{prod.nom_produit}}
        </option>
      </select>
    </div>
    <div class="button-row d-flex align-items-center mb-3">
      <span>Fichier</span>
      <button mat-button class="ml-2" mat-mini-fab (click)="fileHandover.click()" matTooltip="Sélectionner le fichier">
        <mat-icon>insert_drive_file</mat-icon>
      </button>
      <input type="file" accept="application/*,.zip,.p12,.jks,.der,.json" style="display:none" #fileHandover (change)="onFileSelected($event, 'handover')"/>
    </div>
    <div class="btn-group mt-3 mb-5">
      <div><button (click)="uploadFile()" class="btn btn100px btn-dark p-2 mr-2" [disabled]="(file.product == 0 && file.type == 'job') || file.type == ''">Créer</button></div>
      <div><button (click)="onCancel()" class="btn btn-light btn100px border-dark p-2">Annuler</button></div>
    </div>
  </form>
</div>

